import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplatesSectionItemFragment = { __typename: 'Template', id: string, legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, latestRevision?: { __typename: 'TemplateRevision', renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null, organization: { __typename: 'Organization', id: string, name?: string | null } };

export type TemplatesSectionItemsForMaterialQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type TemplatesSectionItemsForMaterialQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, revisions: Array<{ __typename: 'MaterialRevision', templateRevisions: Array<{ __typename: 'TemplateRevision', template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, latestRevision?: { __typename: 'TemplateRevision', renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null, organization: { __typename: 'Organization', id: string, name?: string | null } } | null } | null> }> } };

export type TemplatesReferencedBySectionItemsForTemplateQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type TemplatesReferencedBySectionItemsForTemplateQuery = { __typename: 'Query', template: { __typename: 'Template', revisions: Array<{ __typename: 'TemplateRevision', referencedBy: Array<{ __typename: 'TemplateRevision', template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, latestRevision?: { __typename: 'TemplateRevision', renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null, organization: { __typename: 'Organization', id: string, name?: string | null } } | null }> }> } };

export type TemplatesReferencesSectionItemsForTemplateQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type TemplatesReferencesSectionItemsForTemplateQuery = { __typename: 'Query', template: { __typename: 'Template', revisions: Array<{ __typename: 'TemplateRevision', references: Array<{ __typename: 'TemplateRevision', template?: { __typename: 'Template', id: string, legacyId: number, name?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, latestRevision?: { __typename: 'TemplateRevision', renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null, organization: { __typename: 'Organization', id: string, name?: string | null } } | null }> }> } };

export const TemplatesSectionItemFragmentDoc = gql`
    fragment TemplatesSectionItem on Template {
  id
  legacyId
  name
  galleryImage {
    id
  }
  latestRevision {
    renderedImages(take: 4) {
      id
    }
  }
  organization {
    id
    name
  }
}
    `;
export const TemplatesSectionItemsForMaterialDocument = gql`
    query templatesSectionItemsForMaterial($materialId: ID!) {
  material(id: $materialId) {
    id
    revisions {
      templateRevisions {
        template {
          ...TemplatesSectionItem
        }
      }
    }
  }
}
    ${TemplatesSectionItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesSectionItemsForMaterialGQL extends Apollo.Query<TemplatesSectionItemsForMaterialQuery, TemplatesSectionItemsForMaterialQueryVariables> {
    override document = TemplatesSectionItemsForMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplatesReferencedBySectionItemsForTemplateDocument = gql`
    query templatesReferencedBySectionItemsForTemplate($templateId: ID!) {
  template(id: $templateId) {
    revisions {
      referencedBy {
        template {
          ...TemplatesSectionItem
        }
      }
    }
  }
}
    ${TemplatesSectionItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesReferencedBySectionItemsForTemplateGQL extends Apollo.Query<TemplatesReferencedBySectionItemsForTemplateQuery, TemplatesReferencedBySectionItemsForTemplateQueryVariables> {
    override document = TemplatesReferencedBySectionItemsForTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplatesReferencesSectionItemsForTemplateDocument = gql`
    query templatesReferencesSectionItemsForTemplate($templateId: ID!) {
  template(id: $templateId) {
    revisions {
      references {
        template {
          ...TemplatesSectionItem
        }
      }
    }
  }
}
    ${TemplatesSectionItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesReferencesSectionItemsForTemplateGQL extends Apollo.Query<TemplatesReferencesSectionItemsForTemplateQuery, TemplatesReferencesSectionItemsForTemplateQueryVariables> {
    override document = TemplatesReferencesSectionItemsForTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }